import React from 'react'

import { useTranslation } from 'react-i18next'

import { Stack, TertiaryButton, Text } from '@enechain/ecloud-designsystem'
import { FaPlusRegular, FaSquareListRegular } from '@enechain/ecloud-icons'

type Props = {
  handleAddOrderPattern: () => void
}

export const EmptyOrderPatternSection: React.FC<Props> = ({
  handleAddOrderPattern,
}) => {
  const { t } = useTranslation(['page', 'common'])

  return (
    <Stack
      gap="6"
      alignItems="center"
      justifyContent="center"
      backgroundColor="Surface.secondary"
      borderRadius="radiiXl"
      paddingTop="8"
      paddingBottom="12"
      paddingX="8"
    >
      <Stack gap="4" alignItems="center">
        <FaSquareListRegular
          width="40px"
          height="40px"
          color="Text.lowEmphasis"
        />
        <Stack gap="1" alignItems="center">
          <Text textStyle="headerXs" color="Text.midEmphasis">
            {t('page:simulation.empty_order_pattern')}
          </Text>
          <Text textStyle="textSm" color="Text.lowEmphasis">
            {t('page:simulation.empty_order_pattern_description')}
          </Text>
        </Stack>
      </Stack>
      <TertiaryButton
        leftIcon={<FaPlusRegular />}
        onClick={handleAddOrderPattern}
      >
        {t('common:action.neutral.add', {
          value: t('page:simulation.input_order'),
        })}
      </TertiaryButton>
    </Stack>
  )
}
